// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import http from '@/assets/js/http'
import store from '@/store'
import axios from 'axios'
import cmrJs from '@/util/cmr.js'
import {
  baseUrl,
  baseAcs,
  baseStore,
  baseBPM,
  baseSC,
  baseDSTC,
  baseNonSale,
  baseHKTW,
  baseMDReadiness,
  baseMDM,
  baseSmile,
  baseCOMM
} from "@/assets/js/base-url.js";
import '@/assets/css/font.css'
// import '@/assets/css/theme/index.css'
import ElementUI from 'element-ui'
import $ from 'jquery'
import 'element-ui/lib/theme-chalk/index.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'admin-lte/dist/js/adminlte.min.js'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'admin-lte/dist/css/AdminLTE.min.css'
import 'admin-lte/dist/css/skins/skin-blue.min.css'
import 'ionicons/dist/css/ionicons.min.css'

import 'font-awesome/css/font-awesome.min.css'

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table-plugin-element/dist/style.css'
import './assets/css/common.css'
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'

import PreviewPic from 'vue-preview-pictures'
Vue.prototype.$PreviewPic = PreviewPic
import "vant/lib/button/style";

import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)

import BaiduMap from 'vue-baidu-map';
import wujieVue from 'wujie-vue2'
Vue.use(BaiduMap, {
  ak: 'jw69Raz76OZCozGs1tuqxnzlazsXuyGa'
});

import VueClipboard from 'vue-clipboard2'
import VueBus from 'vue-bus';

Vue.use(VueClipboard)

Vue.config.productionTip = false;
Vue.use(VueBus);
Vue.use(ElementUI);
Vue.use(VXETable);
VXETable.use(VXETablePluginElement);
Vue.prototype.http = http;
Vue.prototype.baseUrl = baseUrl;
Vue.prototype.baseSSO = window.BaseConfigInfo.baseSSO;
Vue.prototype.baseSSOFED = window.BaseConfigInfo.baseSSOFED;
Vue.prototype.baseSSOShared = window.BaseConfigInfo.baseSSOShared;
Vue.prototype.appKey = window.BaseConfigInfo.baseSSO.appKey;
Vue.prototype.baseD1Url = baseStore; // D1 默认指向 Store微服务
Vue.prototype.axios = axios;
Vue.prototype.baseAcsUrl = baseAcs; // ACS 微服务的基础路径
Vue.prototype.baseStoreUrl = baseStore; // POH 微服务的基础路径
Vue.prototype.baseStoreUrl = baseStore; // Store 微服务的基础路径
Vue.prototype.baseBpmUrl = baseBPM; // BPM 微服务的基础路径
Vue.prototype.$baseSC = baseSC; // special channel 微服务的基础路径
Vue.prototype.$baseDSTC = baseDSTC; // DSTC 微服务的基础路径
Vue.prototype.$httpSource = []; // 请求资源组
Vue.prototype.baseCmrUrl = window.BaseConfigInfo.baseSSO.domainNameCmr; // CMR 微服务的基础路径
Vue.prototype.$baseNonSale = baseNonSale; // Non-Sale 微服务的基础路径
Vue.prototype.$baseHKTW = baseHKTW; // HKTW 微服务的基础路径
Vue.prototype.$baseMDReadiness = baseMDReadiness; // MDChecking 微服务的基础路径
Vue.prototype.$baseMDM = baseMDM; // MDM 微服务的基础路径
Vue.prototype.$baseCOMM = baseCOMM; // COMM 微服务的基础路径
const el_scrollBar = (el) => {
  //在元素上加点私货，名字随便取，确保不会和已有属性重复即可，我取名叫做_ps_
  if (el._ps_ instanceof PerfectScrollbar) {
      el._ps_.update();
  } else {
      //el上挂一份属性
      el._ps_ = new PerfectScrollbar(el, { suppressScrollX: false });
  }
};
wujieVue.preloadApp({
  name:'mdm',
  url:window.BaseConfigInfo.lowcode_app_url
})
Vue.directive("scrollBar", {
  //使用inserted钩子函数（初次创建dom）获取使用自定义指令处的dom
  inserted(el, binding, vnode) {
      //判断其样式是否存在position 并且position为"fixed", "absolute"或"relative"
      //如果不符合条件，抛个错误。当然你也可以抛个警告然顺便给其position自动加上"relative"
      //为什么要这么做呢，因为PerfectScrollbar实现原理就是对dom注入两个div，一个是x轴一个是y轴，他们两的position都是absolute。
      //对css稍有常识的人都知道，absolute是相对于所有父节点里设置了position属性的最近的一个节点来定位的，为了能够正确定位，我们要给其设置position属性
      const rules = ["fixed", "absolute", "relative"];
      if (!rules.includes(window.getComputedStyle(el, null).position)) {
          console.error(`perfect-scrollbar所在的容器的position属性必须是以下之一：${rules.join("、")}`)
      }
      //el上挂一份属性
      el_scrollBar(el);
  },
  //更新dom的时候
  componentUpdated(el, binding, vnode, oldVnode) {
      try {
          //vnode.context其实就是vue实例，这里其实无需实例也直接用Vue的静态方法
          //故而也可以写成Vue.nextTick
          vnode.context.$nextTick(
              () => {
                  el_scrollBar(el);
              }
          )
      } catch (error) {
          console.error(error);
          el_scrollBar(el);
      }
  }
});

/* eslint-disable no-new */
/* 路由访问的拦截器， */
router.beforeEach(async (to, from, next) => {
  // console.log(to, from)
  if(baseSSO.environment === 'local'){
    let userInfo =  window.localStorage.getItem('userInfo');
    if(userInfo || to.path === '/local-temporary-lander'){
      let user = JSON.parse(userInfo);
      user = user == null ? {} : user;
      user.currentResource = to.path;
      store.dispatch('setUser', user);

      const lowcodeMenus = store.getters.getLowcodeMenus
      const menuFlag = store.getters.getHasMenus
      if(userInfo && ( !lowcodeMenus || lowcodeMenus.length == 0) && !menuFlag) {
        let loginUrl =
            baseAcs +
            "/acs/role-function/get-function-permission-by-role";
        const res =  await http.get(loginUrl)
        await store.dispatch('generateLowcodeMenu',{menu:res.data,router});
        next(to.fullPath)
      }else{
        next()
      }

    }else{
      next('/local-temporary-lander');
    }
  }else{

// from path等于'/'表示用户按了刷新键或者直接输入url然后按回车键
    // 这种情况下原来的store值会消失，需要重新从后台获取并设置store
    // console.info(to)
    // console.info(from)
    // 当url中带了code时,就将code存储下来
    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    let code = window.localStorage.getItem('code');

    if(to.query.code != null && to.path == '/login'){
      let code = to.query.code;
      let localCode = window.localStorage.getItem('code');
      if(to.path == '/login' && localCode === code){
        window.localStorage.removeItem('code');
      }else{
        window.localStorage.setItem('code', code);
      }
    }
    // let userInfo = {};
    // userInfo.username='zhou.zw@pg.com';
    // userInfo.access_token = '';
    // window.localStorage.setItem('userInfo', JSON.stringify(userInfo));

    userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    // 没有用户，直接去登陆
    if(code == null || userInfo == null){
      window.localStorage.setItem('subscriptionKey', window.BaseConfigInfo.baseSSO.dimension2);
      if(to.path == '/login'){
        next();
      }else{
        const ignoreRedirectPaths = ['/login', '/switch-role', '/logout', '/version-maintenance'];
        if(ignoreRedirectPaths.indexOf(to.path) === -1){
          window.sessionStorage.setItem('redirectAfterLogin', to.fullPath);
        }
        //location.href = baseSSO.login_page;
        next('/login');

      }
    }else{
      userInfo.currentResource = to.path;
      store.dispatch('setUser', userInfo);
      const lowcodeMenus = store.getters.getLowcodeMenus
      const menuFlag = store.getters.getHasMenus
      if((!lowcodeMenus || lowcodeMenus.length == 0) && !menuFlag) {
        let loginUrl =
            baseAcs +
            "/acs/role-function/get-function-permission-by-role";
        const res =  await http.get(loginUrl)
        await store.dispatch('generateLowcodeMenu',{menu:res.data,router});
        next(to.fullPath)
      }else{
        next();
      }
    }
  }

});

const vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

export default vue;

VXETable.setup({
  // 默认表格参数
  size: 'small',
  showOverflow: null,
  showHeaderOverflow: null,
  stripe: false,
  border: false,
  resizable: false,
  fit: true,
  showHeader: true,
  validConfig: {
    message: 'default'
  },
  // 行数据的唯一主键字段名
  rowId: '_ID',
  // 版本号（对于某些带 Storage 数据储存的功能有用到，上升版本号可以用于重置 Storage 数据）
  version: 0,
  // 自定义图标配置（如果全部图标都使用自定义，就不需要引入 Icon 模块了，减少体积）
  icon: {
    sortAsc: 'vxe-icon--caret-top',
    sortDesc: 'vxe-icon--caret-bottom',
    filter: 'vxe-icon--funnel',
    edit: 'vxe-icon--edit-outline',
    tree: 'vxe-icon--caret-right',
    jumpPrev: 'vxe-icon--d-arrow-left',
    jumpNext: 'vxe-icon--d-arrow-right',
    prevPage: 'vxe-icon--arrow-left',
    nextPage: 'vxe-icon--arrow-right',
    msgClose: 'vxe-icon--close',
    msgInfo: 'vxe-icon--info',
    msgSuccess: 'vxe-icon--success',
    msgWarning: 'vxe-icon--warning',
    msgError: 'vxe-icon--error',
    msgLoading: 'vxe-icon--refresh roll'
  },
  // 高级表格默认配置
  grid: {
    proxyConfig: {
      autoLoad: true,
      message: true,
      props: {
        list: null,
        result: 'result',
        total: 'page.total'
      }
    }
  },
  // 默认快捷菜单
  menu: {},
  // 默认 tooltip 主题样式
  tooltip: {
    zIndex: 99,
    theme: 'dark'
  },
  // 默认分页参数
  pager: {
    pageSize: 10,
    pagerCount: 7,
    pageSizes: [10, 15, 20, 50, 100],
    layouts: ['PrevJump', 'PrevPage', 'Jump', 'PageCount', 'NextPage', 'NextJump', 'Sizes', 'Total'] // 非常灵活的分页布局，支持任意位置随意换
  },
  // 默认工具栏参数
  toolbar: {
    setting: false,
    buttons: []
  },
  // 默认消息提示框参数
  message: {
    zIndex: 999,
    lockView: true,
    lockScroll: true,
    mask: true,
    duration: 3000,
    animat: true
  },
  // 默认优化配置项
  optimization : {
    animat: true,
    // 当表头大于 40 列时自动启用横向 X 滚动渲染
    scrollX: {
      gt: 40,
      oSize: 5,
      rSize: 16
    },
    // 当行数据大于 500 条时自动启用纵向 Y 滚动渲染
    scrollY: {
      gt: 500,
      oSize: 20,
      rSize: 80
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js